import {TimelineLite}from 'gsap/umd/TweenMax';

export class Hero {
    heroVideo = document.querySelector('.l-hero__bg');
    heroFirst = document.querySelector('.l-hero__first');
    heroSecond = document.querySelector('.l-hero__second');
    tl = new TimelineLite();

    init() {
        this.tl.call(this.addClass, [this.heroVideo, 'js-animate-loaded'], null, 0.2);

        if (window.matchMedia('(min-width: 1199px)').matches){
            this.tl.call(this.addClass, [this.heroFirst, 'js-animate-loaded'], null, 1);
            this.tl.call(this.addClass, [this.heroFirst, 'js-animate-from-top-20'], null, 2);
            this.tl.call(this.removeClass, [this.heroFirst, 'js-animate-loaded'], null, 3);
            this.tl.call(this.addClass, [this.heroSecond, 'js-animate-loaded'], null, 4);
        }else {
            this.tl.call(this.addClass, [this.heroSecond, 'js-animate-loaded'], null, .5);
        }

    }

    addClass = (element, cls) => {
        element.classList.add(cls);
    }

    removeClass = (element, cls) => {
        element.classList.remove(cls);
    }

    play = () => {
        this.tl.play();
    }

    constructor() {
        this.init();
    }
}



// WEBPACK FOOTER //
// ./app/blocks/hero/hero.js